export const buildNumber = '20260831.8';
export const version = 'main';
export const latestCommit = '7bbb4a165d7c1b5916b233af3e6b571d43a9c87e';
